import { useTranslation } from "react-i18next";
import UpgradeBadge from "../../Utilities/UpgradePath/UpgradeBadge";

function Heading() {
  const { t } = useTranslation(["integrations"]);
  return (
    <div>
      <div
        className="h3 my-3"
        style={{ fontFamily: "Roboto", fontWeight: 600 }}
      >
        <UpgradeBadge featureName="salesforza" />
        <br />
        {t("salesforza.heading.title")}
      </div>
      <div style={{ fontFamily: "Roboto", color: "var(--color-secondary)" }}>
        {t("salesforza.heading.subtitle")}
      </div>
    </div>
  );
}

export default Heading;
